/* esm.sh - applesauce-common@5.2.0/dist/casts/stream */
export * from "/*applesauce-common@5.2.0/esnext/dist/casts/stream.mjs";
